import {createApp} from 'vue'
import ElementPlus from 'element-plus'
import router from "@/router";
import {useStore} from 'vuex'
import store from './store'
import animated from 'animate.css';
import 'element-plus/dist/index.css';
import 'dayjs/locale/zh-cn' //中文
import locale from 'element-plus/lib/locale/lang/zh-cn' //中文
import App from './App.vue'
import vue3videoPlay from 'vue3-video-play' // 引入组件
import 'vue3-video-play/dist/style.css' // 引入css


const app = createApp(App)
app.use(ElementPlus, {locale})
app.use(router)
app.use(store)
app.use(useStore)
app.use(animated)
app.use(vue3videoPlay)
app.mount('#app')
